import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import '../Style/ReactionUsersModal.css';

const REACTION_EMOJIS = {
  FIRE: '🔥',
  STRONG: '💪',
  STAR: '⭐',
  HEART: '❤️',
};

const ReactionUsersModal = ({ isOpen, users = [], onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUserClick = (userId) => {
    onClose();
    navigate(`/profile/${userId}`);
  };

  return createPortal(
    <div className="reaction-modal-overlay" onClick={onClose}>
      <div className="reaction-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="reaction-modal-header">
          <h3>Reactions Today</h3>
          <button className="reaction-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        {users.length === 0 ? (
          <p className="reaction-modal-empty">No reactions yet.</p>
        ) : (
          <div className="reaction-user-list">
            {users.map((user) => (
              <div
                key={user.userId}
                className="reaction-user-row clickable"
                onClick={() => handleUserClick(user.userId)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleUserClick(user.userId);
                }}
              >
                <div className="reaction-user-left">
                  {user.profilePicUrl ? (
                    <img
                      src={user.profilePicUrl}
                      alt={user.firstName}
                      className="reaction-user-avatar"
                    />
                  ) : (
                    <div className="reaction-user-avatar-fallback">
                      {user.firstName?.[0] || '?'}
                    </div>
                  )}

                  <div>
                    <p className="reaction-user-name profile-name-text">
                      {user.firstName} {user.lastName}
                    </p>
                  </div>
                </div>

                <div className="reaction-user-emojis">
                  {user.reactionTypes?.map((type) => (
                    <span key={type}>{REACTION_EMOJIS[type]}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
};

export default ReactionUsersModal;
